<template>
  <div class="ride-detail container-fluid r-aside">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>
    <div class="row page-titles">
        <div class="col-md-5 align-self-center">
            <h3 class="text-themecolor">Ride Details</h3>
        </div>
        <div class="col-md-7 align-self-center">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
                <li class="breadcrumb-item active">Ride Details</li>
            </ol>
        </div>
    </div>

    <div  v-if="ride" class="row">
      <div class="col-12 col-lg-6">
        <div class="card">
          <div class="card-body">
              <div class="d-flex">
                  <h4 class="card-title"><span class="lstick"></span>Ride Info</h4>
                  <!-- <span class="badge badge-success">9</span> -->
                  <div v-if="getUser()['is_agent'] || getUser()['is_admin'] || getUser()['is_superuser']" class="btn-group ml-auto m-t-10">
                      <div data-toggle="dropdown">
                        <a class="icon-options-vertical link" aria-haspopup="true" aria-expanded="false"></a>
                        <span>
                          Options
                        </span>
                      </div>
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" @click="pickup_edit=true; pickup_bk=ride.date_pickup;" data-toggle="modal" data-target="#instructionsModal">Update Pick-up Time ({{ride.date_pickup_local == null ? 'UTC' : 'Local'}})</a>
                        <a class="dropdown-item" @click="instructions_edit=true; instructions_bk=ride.instructions;" data-toggle="modal" data-target="#instructionsModal">Update Instructions</a>
                        <a class="dropdown-item" @click="odometer_edit=true; pickup_odometer_bk=ride.pickup_odometer; dropoff_odometer_bk=ride.dropoff_odometer;" data-toggle="modal" data-target="#instructionsModal">Update Odometers</a>
                        <!--<a class="dropdown-item" @click="pickup_edit=true; instructions_bk=ride.date_pickup;" data-toggle="modal" data-target="#instructionsModal">Update Pickup Time</a>-->
                        <div class="dropdown-divider"></div>

                        <a class="dropdown-item" data-toggle="modal" data-target="#linearModal" v-on:click="popupAtFaultForm('linear')">General Distribution</a>
<!--                        <a class="dropdown-item" data-toggle="modal" data-target="#logarithmicModal" v-on:click="updateRide('logarithmic')">Accelerated Distribution</a>-->
                        <a class="dropdown-item" data-toggle="modal" data-target="#logarithmicModal" v-on:click="popupAtFaultForm('blast')">Blast Ride</a>
                        <a class="dropdown-item" data-toggle="modal" data-target="#cancelModal" v-on:click="showSendBackModal = true">Cancel/Send-Back</a>
                        <a class="dropdown-item" data-toggle="modal" data-target="#noshowRiderModal" v-on:click="updateRide('ridernoshow')">Rider No-Show</a>
                        <a class="dropdown-item" data-toggle="modal" data-target="#noshowDriverModal" v-on:click="popupAtFaultForm('drivernoshow')">Driver No-Show</a>
                        <div class="dropdown-divider"></div>

                        <a class="dropdown-item" v-if="ride.id_type_ride_status && ride.id_type_ride_status.code!='driver_no_show'" @click="showAdditionalModal=true" data-toggle="modal" data-target="#updatePickupModal" style="cursor: pointer">Add Payment/Penalty to the Driver</a>
                        <a class="dropdown-item" v-if="ride.deadhead" @click="showUnloadedModal=true" data-toggle="modal" data-target="#updatePickupModal" style="cursor: pointer">Update Unloaded Miles Payment</a>
                        <div class="dropdown-divider"></div>

                        <a class="dropdown-item" @click="showDriverSelect()">Transfer/Assign</a>
                        <a class="dropdown-item" @click="favoriteDriver()">Favorite Driver</a>
                        <a class="dropdown-item" @click="blacklistDriver()">Blacklist Driver</a>
                        <div class="dropdown-divider"></div>

                        <a class="dropdown-item" @click="confirmRide()">Confirm Ride</a>
                        <a class="dropdown-item" @click="confirmRideVoice()">Confirm Ride via Phone Call</a>
                        <a class="dropdown-item" @click="confirmRideSms()">Confirm Ride via SMS</a>

                        <div v-if="getUser()['is_admin'] || getUser()['is_superuser']" class="dropdown-divider"></div>
                        <a v-if="getUser()['is_admin'] || getUser()['is_superuser']" class="dropdown-item" @click="triplegid_edit=true; triplegid_bk=ride.id_alternate" data-toggle="modal" data-target="#instructionsModal">Update Trip Leg ID</a>
                        <a v-if="getUser()['is_admin'] || getUser()['is_superuser'] || getUser()['is_agent']" class="dropdown-item" @click="showStatusSelectModal = true">Change Status</a>
                        <a v-if="getUser()['is_admin'] || getUser()['is_superuser'] || getUser()['is_agent']" class="dropdown-item" @click="geostamp_edit=true; geopickup_bk=ride.pickup_date; geocheck_bk = ride.check_date; geoenroute_bk=ride.enroute_date; geodropoff_bk = ride.dropoff_date; " data-toggle="modal" data-target="#instructionsModal">Update Times</a>
                        <a v-if="getUser()['is_admin'] || getUser()['is_superuser']" class="dropdown-item" @click="markRideSigned(ride.id_ride)">Mark as signed</a>
                      </div>
                  </div>
              </div>
          </div>
          <div class="card-body">
            <table class="table-no-bordered table table-sm borderless ">
              <tbody>
              <tr>
                <td class="font-weight-bold">Ride ID#:</td>
                <td>{{ ride.id_ride }}<a target="_blank" style="padding-left: 15px;" :href="ride.weblink">Tracking Link</a></td>
              </tr>
              <!-- <tr>
                <td class="font-weight-bold">Legacy ID#:</td>
                <td>{{ ride.id_legacy ? ride.id_legacy : 'N/A' }}</td>
              </tr> -->
              <tr>
                <td class="font-weight-bold">Leg ID#:</td>
                <td v-if="!triplegid_edit">{{ ride.id_alternate ? ride.id_alternate : 'N/A' }}</td>
                <td v-else>
                  <input v-model = "ride.id_alternate" class="form-control form-control-sm" placeholder="" style="width:100%" type="text">
                  <font-awesome-icon @click="triplegid_edit=false; ride.id_alternate=triplegid_bk" icon="times" style="float:right; margin:5px; color: rgb(239, 83, 80); cursor: pointer"/>
                  <font-awesome-icon @click="triplegid_edit=false; updateRide('id_alternate')" icon="check" style="float:right; margin:5px; color: rgb(38, 166, 154); cursor: pointer"/>
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Trip ID#:</td>
                <router-link :to="'/search-rides/?id_group_ride=' + ride.id_group_ride" v-if="ride.id_group_ride" style="padding: 0.3rem;" target="_blank">
                  {{ ride.id_group_ride }}
                </router-link>

                <td v-if="!ride.id_group_ride">{{ 'N/A' }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Standing Order ID#:</td>
                <td>{{ ride.standing_order_id ? ride.standing_order_id : 'N/A' }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Multiload ID#:</td>
                <td>{{ ride.id_multiload ? ride.id_multiload : 'N/A' }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Ride Type:</td>
                <td>{{ ride.deadhead && ride.deadhead == true ? 'Deadhead' : ride.id_booking_organization ? ride.id_booking_organization.name ? ride.id_booking_organization.name : 'Booking Organization' : 'Regular'}}</td>
              </tr>
              <tr v-if="rideVehicleType">
                <td class="font-weight-bold">Vehicle Type:</td>
                <td>{{ rideVehicleType }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Will Call:</td>
                <td>{{ ride.ride_type == 'will-call' ? 'Yes' : 'No' }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Market:</td>
                <td>{{ ride.id_market && ride.id_market.name ? ride.id_market.name : 'N/A'}}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Status:</td>
                <td>{{ ride.id_type_ride_status && ride.id_type_ride_status.name ? ride.id_type_ride_status.name + (ride.set_cancellation_reason ? (' - ' + ride.set_cancellation_reason) : '') : ride.id_type_ride_status && ride.id_type_ride_status.code ? ride.id_type_ride_status.code : 'Unknown' }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Local Timezone:</td>
                <td>{{ !ride.local_timezone ? 'N/A' : ride.local_timezone }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Booked:</td>
                <td>{{ !ride.date_reservation ? 'N/A' : ride.local_timezone ? moment.utc(ride.date_reservation).tz(ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') : (moment.utc(ride.date_reservation).format('MMMM Do YYYY, h:mm:ss a (z)'))}}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Expiration Time:</td>
                <td>{{ !ride.date_expiration ? 'N/A' : ride.local_timezone ? moment.utc(ride.date_expiration).tz(ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') : moment.utc(ride.date_expiration).format('MMMM Do YYYY, h:mm:ss a (z)')}}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Accepted Time:</td>
                <td>{{ !ride.date_accepted ? 'N/A' : ride.local_timezone ? moment.utc(ride.date_accepted).tz(ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') : moment.utc(ride.date_accepted).format('MMMM Do YYYY, h:mm:ss a (z)')}}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Assigned Time:</td>
                <td>{{ !ride.date_assigned ? 'N/A' : ride.local_timezone ? moment.utc(ride.date_assigned).tz(ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') : moment.utc(ride.date_assigned).format('MMMM Do YYYY, h:mm:ss a (z)')}}</td>
              </tr>
              <tr class="col-md-2 col-lg-3 m-2 p-0 form-ddown">
                <td class="font-weight-bold">UTC Pickup Date:</td>
                <td>
                  <div v-show="pickup_edit == false || (pickup_edit == true && ride.date_pickup_local != null)">
                    {{ !ride.date_pickup ? 'N/A' : moment.utc(ride.date_pickup).format('MMMM Do YYYY, h:mm:ss a')}}
                  </div>
                  <div v-show="pickup_edit == true && ride.date_pickup_local == null">
                    <div style="display: flex; flex-direction: row; align-items: center; ">
                      <datetime type="datetime"  v-model="ride.date_pickup" label="Pickup Time" input-class="form-control form-control-sm" placeholder="Pickup Time" >
                      </datetime>
                      <font-awesome-icon @click="pickup_edit=false; ride.date_pickup=pickup_bk" icon="times" style="float:right; margin:5px; color: rgb(239, 83, 80); cursor: pointer"/>
                      <font-awesome-icon @click="pickup_edit=false; updateRide('date_pickup')" icon="check" style="float:right; margin:5px; color: rgb(38, 166, 154); cursor: pointer"/>
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="col-md-2 col-lg-3 m-2 p-0 form-ddown">
                <td class="font-weight-bold">Local Pickup Date:</td>
                <td>
                  <div v-show="pickup_edit == false && ride.date_pickup_local != null">
                    {{ !ride.date_pickup_local ? 'N/A' : moment.utc(ride.date_pickup_local).format('MMMM Do YYYY, h:mm:ss a')}}
                  </div>
                  <div v-show="pickup_edit == true && ride.date_pickup_local != null">
                    <div style="display: flex; flex-direction: row; align-items: center; ">
                      <datetime type="datetime"  v-model="ride.date_pickup" label="Pickup Time" input-class="form-control form-control-sm" placeholder="Pickup Time" >
                      </datetime>
                      <font-awesome-icon @click="pickup_edit=false; ride.date_pickup=pickup_bk" icon="times" style="float:right; margin:5px; color: rgb(239, 83, 80); cursor: pointer"/>
                      <font-awesome-icon @click="pickup_edit=false; updateRide('date_pickup')" icon="check" style="float:right; margin:5px; color: rgb(38, 166, 154); cursor: pointer"/>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">From Address Name:</td>
                <td>{{ ride.default_pickup_address_name ? ride.default_pickup_address_name : 'N/A' }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">From Address:</td>
                <td>{{ ride.default_pickup_address ? ride.default_pickup_address : 'N/A' }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">To Address Name:</td>
                <td>{{ ride.default_dropoff_address_name ? ride.default_dropoff_address_name : 'N/A' }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">To Address:</td>
                <td>{{ ride.default_dropoff_address ? ride.default_dropoff_address : 'N/A' }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Passengers:</td>
                <td>{{ ride.amount_riders ? ride.amount_riders : 'N/A' }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Member ID:</td>
                <td>{{ ride.id_rider & ride.id_rider.id_alternate ? ride.id_rider.id_alternate : "N/A" }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Contact Rider:</td>
                <td>{{ (ride.contact_first_name ? ride.contact_first_name : ride.id_rider.name_first) + " " + (ride.contact_last_name ? ride.contact_last_name : ride.id_rider.name_last) }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Contact Email:</td>
                <td>{{ ride.contact_email ? ride.contact_email : "N/A" }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Member Phone:</td>
                <td>{{ ride.contact_phone ? formatPhoneNumber(ride.contact_phone) : "N/A" }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Pickup Phone:</td>
                <td>{{ ride.contact_pickup_phone ? formatPhoneNumber(ride.contact_pickup_phone) : "N/A" }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Dropoff Phone:</td>
                <td>{{ ride.contact_dropoff_phone ? formatPhoneNumber(ride.contact_dropoff_phone) : "N/A" }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Notification Method:</td>
                <td>{{ ride.notification_method ? ride.notification_method : "N/A" }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Instructions:</td>
                <td>
                  <div v-show="instructions_edit == false">
                        <span>
                          {{ ride.instructions }}
                        </span>
                  </div>
                    <textarea autofocus v-show = "instructions_edit == true"
                              v-model = "ride.instructions" rows="5" class="edit-instructions form-control">
                    </textarea>
                  <font-awesome-icon v-if="instructions_edit==true" @click="instructions_edit=false; ride.instructions=instructions_bk" icon="times" style="float:right; margin:5px; color: rgb(239, 83, 80); cursor: pointer"/>
                  <font-awesome-icon v-if="instructions_edit==true" @click="instructions_edit=false; updateRide('instructions')" icon="check" style="float:right; margin:5px; color: rgb(38, 166, 154); cursor: pointer"/>

                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Expected Duration:</td>
                <td>{{ ride.default_duration_p_to_d ? (ride.default_duration_p_to_d/60).toFixed(2) : 'N/A' }} minutes</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Expected Distance:</td>
                <td>{{ ride.default_distance_p_to_d ? ride.default_distance_p_to_d.toFixed(2) : 'N/A' }} miles</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Check Time:</td>
                <td v-if="!geostamp_edit">{{ !ride.check_date ? 'N/A' : ride.local_timezone ? moment.utc(ride.check_date).tz(ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') : moment.utc(ride.check_date).format('MMMM Do YYYY, h:mm:ss a (z)') }}</td>
                <td v-else>
                  <div style="display: flex; flex-direction: row; align-items: center; ">
                    <datetime type="datetime"  v-model="ride.check_date" label="Check Time" input-class="form-control form-control-sm" placeholder="Check Time" />
                    <font-awesome-icon @click="geostamp_edit=false; ride.check_date=geocheck_bk" icon="times" style="float:right; margin:5px; color: rgb(239, 83, 80); cursor: pointer"/>
                    <font-awesome-icon @click="geostamp_edit=false; updateRide('geostamp')" icon="check" style="float:right; margin:5px; color: rgb(38, 166, 154); cursor: pointer"/>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">En-Route Time:</td>
                <td v-if="!geostamp_edit">{{ !ride.enroute_date ? 'N/A' : ride.local_timezone ? moment.utc(ride.enroute_date).tz(ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') : moment.utc(ride.enroute_date).format('MMMM Do YYYY, h:mm:ss a (z)') }}</td>
                <td v-else>
                  <div style="display: flex; flex-direction: row; align-items: center; ">
                    <datetime type="datetime"  v-model="ride.enroute_date" label="En-route Time" input-class="form-control form-control-sm" placeholder="En-route Time" />
                    <font-awesome-icon @click="geostamp_edit=false; ride.enroute_date=geoenroute_bk" icon="times" style="float:right; margin:5px; color: rgb(239, 83, 80); cursor: pointer"/>
                    <font-awesome-icon @click="geostamp_edit=false; updateRide('geostamp')" icon="check" style="float:right; margin:5px; color: rgb(38, 166, 154); cursor: pointer"/>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Pickup Time:</td>
                <td v-if="!geostamp_edit">{{ !ride.pickup_date ? 'N/A' : ride.local_timezone ? moment.utc(ride.pickup_date).tz(ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') : moment.utc(ride.pickup_date).format('MMMM Do YYYY, h:mm:ss a (z)') }}</td>
                <td v-else>
                  <div style="display: flex; flex-direction: row; align-items: center; ">
                    <datetime type="datetime"  v-model="ride.pickup_date" label="Pickup Time" input-class="form-control form-control-sm" placeholder="Pickup Time" />
                    <font-awesome-icon @click="geostamp_edit=false; ride.pickup_date=geopickup_bk" icon="times" style="float:right; margin:5px; color: rgb(239, 83, 80); cursor: pointer"/>
                    <font-awesome-icon @click="geostamp_edit=false; updateRide('geostamp')" icon="check" style="float:right; margin:5px; color: rgb(38, 166, 154); cursor: pointer"/>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Pickup Odometer:</td>
                <td>
                  <div v-show="odometer_edit == false">
                        <span>
                          {{ !ride.pickup_odometer ? 'N/A' : ride.pickup_odometer}}
                        </span>
                  </div>
                  <input autofocus v-show = "odometer_edit == true"
                            v-model = "ride.pickup_odometer" rows="5" class="edit-instructions form-control" />
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Drop-off Time:</td>
                <td v-if="!geostamp_edit">{{ !ride.dropoff_date ? 'N/A' : ride.local_timezone ? moment.utc(ride.dropoff_date).tz(ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') : moment.utc(ride.dropoff_date).format('MMMM Do YYYY, h:mm:ss a (z)') }}</td>
                <td v-else>
                  <div style="display: flex; flex-direction: row; align-items: center; ">
                    <datetime type="datetime"  v-model="ride.dropoff_date" label="Drop-off Time" input-class="form-control form-control-sm" placeholder="Drop-off Time" />
                    <font-awesome-icon @click="geostamp_edit=false; ride.dropoff_date=geodropoff_bk" icon="times" style="float:right; margin:5px; color: rgb(239, 83, 80); cursor: pointer"/>
                    <font-awesome-icon @click="geostamp_edit=false; updateRide('geostamp')" icon="check" style="float:right; margin:5px; color: rgb(38, 166, 154); cursor: pointer"/>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Dropoff Odometer:</td>
                <td>
                  <div v-show="odometer_edit == false">
                        <span>
                          {{ !ride.dropoff_odometer ? 'N/A' : ride.dropoff_odometer}}
                        </span>
                  </div>
                  <input autofocus v-show = "odometer_edit == true"
                         v-model = "ride.dropoff_odometer" rows="5" class="edit-instructions form-control" />
                  <font-awesome-icon v-if="odometer_edit==true" @click="odometer_edit=false; ride.pickup_odometer=pickup_odometer_bk; ride.dropoff_odometer=dropoff_odometer_bk" icon="times" style="float:right; margin:5px; color: rgb(239, 83, 80); cursor: pointer"/>
                  <font-awesome-icon v-if="odometer_edit==true" @click="odometer_edit=false; updateRide('odometer')" icon="check" style="float:right; margin:5px; color: rgb(38, 166, 154); cursor: pointer"/>

                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Total Fare:</td>
                <td>{{ ride.price_total ? "$" + ride.price_total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : "N/A" }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Driver's Revenue:</td>
                <td v-if="ride.price_driver_revenue">${{ride.price_driver_revenue ? ride.price_driver_revenue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : 'N/A'}}</td>
                <td v-else>N/A</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Additional Payment:</td>
                <td v-if="ride.price_additional">
                  {{ride.price_additional ? ((ride.price_additional < 0 ? '-' : '') + '$' + (Math.abs(ride.price_additional.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'))).toString()) : 'N/A'}}
                </td>
                <td v-else>N/A</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Unloaded Miles Payment:</td>
                <td v-if="ride.price_unloaded">
                  {{ride.price_unloaded ? ((ride.price_unloaded < 0 ? '-' : '') + '$' + (Math.abs(ride.price_unloaded.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'))).toString()) : 'N/A'}}
                </td>
                <td v-else>N/A</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Booking Fee:</td>
                <td>{{ ride.price_booking_fee ? "$" + ride.price_booking_fee.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : "N/A" }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Insurance Fee:</td>
                <td>{{ ride.price_insurance_fee ? "$" + ride.price_insurance_fee.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : "N/A" }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Platform Fee:</td>
                <td>{{ ride.price_application_fee ? "$" + ride.price_application_fee.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : "N/A" }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Platform revenue:</td>
                <td>{{ ride.price_application_revenue ? "$" + ride.price_application_revenue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : "N/A" }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Amount reimbursed:</td>
                <td>{{ ride.reimbursed_amount == null ? 'N/A' : ride.reimbursed_amount }}</td>
              </tr>
              <!-- <tr v-for="tag in ride.tag_values">
                <td class="font-weight-bold">{{ tag.name }}:</td>
                <td>{{ tag.values === undefined || tag.values.length == 0 ? 'N/A' : (tag.values.map(function(item){ return item.value; })).join(', ') }}</td>
              </tr> -->
              <!--<tr>-->
                <!--<td class="font-weight-bold">Pricing data:</td>-->
                <!--<td><button v-on:click="showPricingData = true" class="btn btn-link" style="padding: 0">Show</button></td>-->
              <!--</tr>-->
              <tr>
                <button v-on:click="showSSSSModal = true" class="btn btn-info waves-effect waves-light m-t-10" >See Something Say Something</button>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
              <div class="d-flex">
                  <h4 class="card-title"><span class="lstick"></span>Comments</h4>
              </div>
          </div>
          <div class="card-body">
            <!-- <div class="col-12 mt-3 mb-3 text-center">
              <h4>Comments</h4>
            </div> -->

            <div class="col-12 row ">
              <!-- <div class="col-12 mb-3" style="text-align: left; overflow-y: scroll; max-height:400px;">
                <div v-for="comment in comments" class="col-12 mt-2 p-3 border">
                  <p class="pull-right">
                    <small>{{ comment.created_at | moment('timezone', ride.id_rider.location_timezone, "MMMM Do, YYYY \\at h:mm a") }}</small>
                  </p>
                  <div class="media-body">
                    <h6 class="media-heading user_name">{{ comment.commented_by.name_first + ' ' + comment.commented_by.name_last}}</h6>
                    <p>{{comment.content}}</p>
                  </div>
                </div>
              </div> -->
              <div class="col-12 table-responsive">
                <table id="comments-table" class="table table-sm table-hover">
                  <thead ><tr><td style="border:none;"></td></tr></thead>
                  <tbody>
                    <tr v-for="comment in comments" class="col-12 mt-2 p-3" v-bind:style="comment.content_type == 'action' ? 'background-color:#f3f1f1' : ''">
                      <td>
                        <p class="pull-right">
                          <small>{{moment(comment.created_at).format("MMMM Do, YYYY \\at h:mm a") + " (" + moment.tz(moment.tz.guess()).format('z') + ")" }}</small>
                        </p>
                        <div class="media-body">
                          <h6 class="media-heading user_name">{{ comment.commented_by.name_first + ' ' + comment.commented_by.name_last}}</h6>
                          <p>{{comment.content}}</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-12 mt-2 p-3">
                <textarea class="form-control form-sm" style="height: 100px;" name="comment[comment]"
                  id="comment_comment" v-model="comment_content"></textarea>
                <button @click="addComment()" type="submit" name="commit" value="Add Comment"
                  class="btn btn-info waves-effect waves-light m-t-10" data-disable-with="Add Comment">Add Comment</button>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="card">
          <div class="card-body">
              <div class="d-flex">
                  <h4 class="card-title"><span class="lstick"></span>Rider</h4>
              </div>
          </div>
          <div class="card-body">
            <table v-if="ride.id_rider" class="table-no-bordered table table-sm borderless">
              <tbody>
              <tr>

              </tr>
              <tr>
                <td colspan="2" class="text-center p-3">
                  <router-link :to="'/users/' + ride.id_rider.id_user + '/'">
                    <img v-if="ride.id_rider.id_profile_image" class="rounded-circle" style="height: 100px; width: 100px; object-fit: cover;"
                        :src="ride.id_rider.id_profile_image.url"
                        alt="No profile picture">
                    <font-awesome-icon v-if="!ride.id_rider.id_profile_image" icon="user-circle" style="height: 100px; width: 100px; color: grey;"/>
                  </router-link>
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold ">Number of Rides:</td>
                <td class="">{{ ride.id_rider.rider_rides_amount ? ride.id_rider.rider_rides_amount : 'N/A' }}</td>
              </tr>
              <!--<tr>-->
              <!--<td class="font-weight-bold ">Rating:</td>-->
              <!--<td class="">5.0</td>-->
              <!--</tr>-->
              <!--<tr>-->
              <!--<td colspan="2">&nbsp;</td>-->
              <!--</tr>-->
              <tr>
                <td class="font-weight-bold ">Id#:</td>
                <td class="">{{ ride.id_rider.id_user ? ride.id_rider.id_user : 'N/A' }}</td>
              </tr>
              <!--<tr>-->
              <!--<td class="font-weight-bold ">Referral Code:</td>-->
              <!--<td class="">sergead</td>-->
              <!--</tr>-->
              <tr>
                <td class="font-weight-bold ">First Name:</td>
                <td class="">{{ ride.contact_first_name ? ride.contact_first_name : ride.id_rider ? ride.id_rider.name_first : 'N/A' }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold ">Last Name:</td>
                <td class="">{{ ride.contact_last_name ? ride.contact_last_name : ride.id_rider.name_last ? ride.id_rider.name_last : 'N/A' }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold ">Email:</td>
                <td class="">{{ ride.contact_email ? ride.contact_email : ride.id_rider.email ? ride.id_rider.email : 'N/A' }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold ">Phone number:</td>
                <td class="">
                  <a v-if="ride.id_rider.phone_number != null" href="https://countrycode.org/US">{{ ride.contact_phone ? formatPhoneNumber(ride.contact_phone) : ride.id_rider.phone_number ? formatPhoneNumber(ride.id_rider.phone_number) : 'N/A' }}</a>
                  <span v-else>N/A</span>
                </td>
              </tr>
              <tr class="">
                <!--<td class="text-center pt-4">-->
                <!--<button name="button" type="submit" class="btn btn-primary btn-xs p-2 pr-3 pl-3" data-toggle="modal"-->
                <!--data-target="#fraudulentUserModal">Fraudulent User-->
                <!--</button>-->
                <!--</td>-->
                <!--<td colspan="2" class="text-center pt-4">-->
                  <!--<button name="button" type="submit" class="btn btn-primary btn-xs p-2 pr-3 pl-3" data-toggle="modal"-->
                          <!--data-target="#deleteUserModal">Delete User-->
                  <!--</button>-->
                <!--</td>-->
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
              <div class="d-flex">
                  <h4 class="card-title"><span class="lstick"></span>Driver</h4>
              </div>
          </div>
          <div class="card-body">
            <table v-if="ride.id_driver" class="table-no-bordered table table-sm borderless">
              <tbody>
              <tr>
                <td colspan="2" class="text-center p-3">
                  <router-link :to="'/drivers/' + ride.id_driver.id_user + '/'">
                    <img v-if="ride.id_driver.id_profile_image" class="rounded-circle" style="height: 100px; width: 100px; object-fit: cover;"
                        :src="ride.id_driver.id_profile_image.url"
                        alt="No profile picture">
                    <font-awesome-icon v-if="!ride.id_driver.id_profile_image" icon="user-circle" style="height: 100px; width: 100px; color: grey;"/>
                  </router-link>
                </td>
              </tr>

              <tr>
                <td class="font-weight-bold">Number of Rides:</td>
                <td>{{ ride.id_driver.rides_amount }}</td>
              </tr>
              <!--<tr>-->
              <!--<td class="font-weight-bold">Rating:</td>-->
              <!--<td>4.7792</td>-->
              <!--</tr>-->
              <!--<tr>-->
              <!--<td colspan="2">&nbsp;</td>-->
              <!--</tr>-->
              <tr>
                <td class="font-weight-bold">Id:</td>
                <td>{{ ride.id_driver.id_user }}</td>
              </tr>
              <!--<tr>-->
              <!--<td class="font-weight-bold">Referral Code:</td>-->
              <!--<td>harminderjd</td>-->
              <!--</tr>-->
              <tr>
                <td class="font-weight-bold">First Name:</td>
                <td>{{ ride.id_driver.name_first }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Last Name:</td>
                <td>{{ ride.id_driver.name_last }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Email:</td>
                <td>{{ ride.id_driver.email }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Phone number:</td>
                <td>
                  <a v-if="ride.id_driver.phone_number != null" href="https://countrycode.org/US">{{ formatPhoneNumber(ride.id_driver.phone_number) }}</a>
                  <span v-else>N/A</span>
                </td>
              </tr>
               <tr>
                <td class="font-weight-bold ">Vehicle Type:</td>
                <td class="">{{ vehicleType }}</td>
              </tr>
              </tbody>
            </table>
            <div v-if="!ride.id_driver" style="text-align: center;">
              <span>N/A</span>
            </div>

          </div>
        </div>
        <div class="card">
          <div class="card-body">
              <div class="d-flex">
                  <h4 class="card-title"><span class="lstick"></span>Vehicle Used for This Trip</h4>
              </div>
          </div>
          <div class="card-body">
            <table v-if="ride.id_vehicle" class="table-no-bordered table table-sm borderless ">
              <tbody>
              <tr>
                <td colspan="2" class="text-center p-3">
                  <img v-if="ride.id_vehicle && ride.id_vehicle.id_image" class="" style="max-height: 200px; max-width: 200px;"
                      :src="ride.id_vehicle.id_image.url"
                      alt="A13553cd07ac273dc7118c8c5985e19344033417086e7f4e1e7a8aeafbb525f8">
                  <font-awesome-icon v-if="!ride.id_vehicle || !ride.id_vehicle.id_image" icon="car" style="height: 100px; width: 100px; color: grey;"/>
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Make &amp; model:</td>
                <td v-if="ride.id_vehicle && ride.id_vehicle.id_make_vehicle">{{ ride.id_vehicle.id_make_vehicle.name }}/{{ ride.id_vehicle.model }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Category:</td>
                <td v-if="ride.id_vehicle && ride.id_vehicle.id_type_vehicle">{{ ride.id_vehicle.id_type_vehicle.code }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Capacity:</td>
                <td v-if="ride.id_vehicle && ride.id_vehicle.id_type_vehicle">{{ ride.id_vehicle.id_type_vehicle.capacity }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">License plate:</td>
                <td v-if="ride.id_vehicle">{{ ride.id_vehicle.license_plate_number }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">VIN:</td>
                <td v-if="ride.id_vehicle">{{ ride.id_vehicle.vin }}</td>
              </tr>
              </tbody>
            </table>
            <div v-if="!ride.id_vehicle" style="text-align: center;">
              <span>N/A</span>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <h4 class="card-title"><span class="lstick"></span>Proxy Info</h4>
            </div>
          </div>
          <div class="card-body">
            <!-- <div class="col-12 mt-3 mb-3 text-center">
              <h4>Comments</h4>
            </div> -->
            <div v-if="!ride.proxy || !ride.proxy.id_ride" style="text-align: center;">
              <span>N/A</span>
            </div>

            <div v-if="ride.proxy && ride.proxy.id_ride" class="col-12 row ">
              <div class="col-12 mb-3" style="text-align: left; overflow-y: scroll; max-height:400px;">
                <div v-for="comment in comments" class="col-12 mt-2 p-3 border">
                  <p class="pull-right">
                    <small>{{ comment.created_at | moment('timezone', ride.id_rider.location_timezone, "MMMM Do, YYYY \\at h:mm a") }}</small>
                  </p>
                  <div class="media-body">
                    <h6 class="media-heading user_name">{{ comment.commented_by.name_first + ' ' + comment.commented_by.name_last}}</h6>
                    <p>{{comment.content}}</p>
                  </div>
                </div>
              </div>



              <div class="col-12 table-responsive">
                <table id="proxy-table" class="table table-sm table-hover">
                  <thead ><tr><td style="border:none;"></td></tr></thead>
                  <tbody>
                  <tr class="col-12 mt-2 p-3">
                    <td class="font-weight-bold">
                      Proxy Number
                    </td>
                    <td class="font-weight-bold">
                      {{parsePhoneNumber('+' + ride.proxy.proxy_number).formatNational()}}
                    </td>
                  </tr>
                  <tr class="col-12 mt-2 p-3">
                    <td class="font-weight-bold">
                      Rider has to use the number
                    </td>
                    <td>
                      {{ (ride.contact_phone && ride.contact_phone.length >= 10)? parsePhoneNumber('+1' + ride.contact_phone).formatNational() : 'N/A'}}
                    </td>
                  </tr>
                  <tr class="col-12 mt-2 p-3">
                    <td class="font-weight-bold">
                      Driver has to use the number
                    </td>
                    <td>
                      {{ (ride.id_driver && ride.id_driver.phone_number.length >= 10) ? parsePhoneNumber('+1' + ride.id_driver.phone_number.replace('+1','')).formatNational() : 'N/A'}}
                    </td>
                  </tr>
                  <tr class="col-12 mt-2 p-3">
                    <td class="font-weight-bold">
                      Status
                    </td>
                    <td>
                      {{ride.proxy.closed_at ? 'Inactive' : 'Active'}}
                    </td>
                  </tr>
                  <tr class="col-12 mt-2 p-3">
                    <td class="font-weight-bold">
                      Created at
                    </td>
                    <td>
                      {{ride.proxy.created_at ? moment.utc(ride.proxy.created_at).tz(ride.local_timezone).format('MM/DD/YY  HH:mm z') : 'N/A'}}
                    </td>
                  </tr>
                  <tr class="col-12 mt-2 p-3">
                    <td class="font-weight-bold">
                      Scheduled to be closed at
                    </td>
                    <td>
                      {{ride.proxy.scheduled_close_at ? moment.utc(ride.proxy.scheduled_close_at).tz(ride.local_timezone).format('MM/DD/YY  HH:mm z') : 'N/A'}}
                    </td>
                  </tr>
                  <tr class="col-12 mt-2 p-3">
                    <td class="font-weight-bold">
                      Closed at
                    </td>
                    <td>
                      {{ride.proxy.closed_at ? moment.utc(ride.proxy.closed_at).tz(ride.local_timezone).format('MM/DD/YY  HH:mm z') : 'N/A'}}
                    </td>
                  </tr>
                  <tr class="col-12 mt-2 p-3">
                    <td class="font-weight-bold">
                      Removed at
                    </td>
                    <td>
                      {{ride.proxy.deleted_at ? moment.utc(ride.proxy.deleted_at).tz(ride.local_timezone).format('MM/DD/YY  HH:mm z') : 'N/A'}}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div class="col-12 mt-2 p-3">
                <button @click="showProxyInteractionsModal=true;" type="button" name="commit" value=""
                        class="btn btn-success waves-effect waves-light m-t-10" data-disable-with="">Proxy Events</button>
                <button @click="createProxy()" type="submit" name="commit" value=""
                        class="btn btn-info waves-effect waves-light m-t-10" data-disable-with="">Create Proxy</button>
                <button @click="changeProxyNumber()" type="submit" name="commit" value=""
                        class="btn btn-info waves-effect waves-light m-t-10" data-disable-with="">Change Proxy Number</button>
                <button @click="closeProxy()" type="button" name="commit" value=""
                        class="btn btn-danger waves-effect waves-light m-t-10" data-disable-with="">Close Proxy</button>
                <button @click="removeProxy()" type="button" name="commit" value=""
                        class="btn btn-warning waves-effect waves-light m-t-10" data-disable-with="">Remove Proxy</button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>


    <div v-if="ride" class="col-12 mt-4 row">
      <div class="col-12 col-lg-12">
          <div class="card">
            <div class="card-body">
                <div class="d-flex">
                    <h4 class="card-title"><span class="lstick"></span>Events Logs</h4>
                </div>
            </div>
            <div class="card-body">
              <table class="table table-sm table-hover">
                <thead>
                <tr>
                  <th>User ID</th>
                  <th>Profile</th>
                  <th>At</th>
                  <th>Ride Status</th>
                  <th>Notification Type</th>
                  <th>Description</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="event in ride.ride_events">
                  <td>
                    <router-link :to="'/users/' + event.id_user.id_user + '/'">
                      {{ event.id_user.id_user }}
                    </router-link>
                  </td>
                  <td>
                    <router-link :to="'/users/' + event.id_user.id_user + '/'">
                      {{ event.id_user ? (event.id_user.name_first ? event.id_user.name_first : '') + ' ' + (event.id_user.name_last ? event.id_user.name_last : '') : event.user_type ? event.user_type : 'N/A' }}
                    </router-link>
                  </td>
                  <td>
                    <!--{{ moment(event.created_at).format("YYYY-MM-DD HH:mm") + " (" + moment.tz(moment.tz.guess()).format('z') + ")" }}-->
                    {{ !event.created_at ? 'N/A' : ride.local_timezone ? moment.utc(event.created_at).tz(ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') : moment.utc(event.created_at).format('MMMM Do YYYY, h:mm:ss a (z)')}}
                  </td>
                  <td>{{ event.id_type_ride_status ? (event.id_type_ride_status.name ? event.id_type_ride_status.name : event.id_type_ride_status.code ? event.id_type_ride_status.code : 'N/A') : 'N/A' }}</td>
                  <td>{{ event.event_type ? event.event_type : 'N/A' }}</td>
                  <td>{{ event.description ? event.description : 'N/A' }}</td>
                </tr>
                <tr v-if="ride.ride_events.length==0" style="text-align: center;">
                  <td colspan="6">N/A</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <h4 class="card-title"><span class="lstick"></span>Transactions</h4>
            </div>
          </div>
          <div class="card-body">
            <table class="table table-sm table-hover">
              <thead>
              <tr>
                <th>Transaction ID</th>
                <th>Type</th>
                <th>To</th>
                <th>Amount</th>
                <th>Date Created</th>
                <th>Date Approved</th>
                <th>Claims Status</th>
                <th>Description</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="tran in ride.ride_transactions">
                <td>
                  {{tran.id_transaction}}
                </td>
                <td>
                  {{tran.id_type_transaction.code}}
                </td>
                <td>
                  <router-link :to="'/drivers/' + tran.to_id_user.id_user + '/'">
                    {{ tran.to_id_user.name_first + " " + tran.to_id_user.name_last }}
                  </router-link>
                </td>
                <td>
                  ${{tran.amount}}
                </td>
                <td>
                  {{ !tran.date_transaction ? 'N/A' : ride.local_timezone ? moment.utc(tran.date_transaction).tz(ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') : moment.utc(tran.date_transaction).format('MMMM Do YYYY, h:mm:ss a (z)')}}
                </td>
                <td>
                  {{ !tran.date_approved ? 'N/A' : ride.local_timezone ? moment.utc(tran.date_approved).tz(ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') : moment.utc(tran.date_approved).format('MMMM Do YYYY, h:mm:ss a (z)')}}
                </td>
                <td>{{ (!tran.id_type_claims_status || tran.id_type_claims_status.code == 'not_provided') ? "default status" : tran.id_type_claims_status.code }}</td>
                <td>{{ tran.comment ? tran.comment : 'N/A' }}</td>
              </tr>
              <tr v-if="ride.ride_transactions.length!=0" style="text-align: left;">
                <td colspan="8" style="font-weight: bold">Total paid: ${{ride.total_paid}}</td>
              </tr>
              <tr v-if="ride.ride_transactions.length==0" style="text-align: center;">
                <td colspan="8">N/A</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

          <div class="card">
            <div class="card-body">
                <div class="d-flex">
                    <h4 class="card-title"><span class="lstick"></span>Distribution Logs</h4>
                </div>
            </div>
            <div class="card-body">
              <table class="table table-sm table-hover">
                <thead>
                <tr>
                  <th>Task ID</th>
                  <th>Action</th>
                  <th>Distribution Method</th>
                  <th>Driver</th>
                  <th>Scheduled For</th>
                  <th>Status</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="task in ride.ride_distributions">
                  <td>{{task.id_ride_distribution}}</td>
                  <td>Distribution Pool</td>
                  <td>{{task.distribution_method == 'LINEAR' ? 'General Distribution' : (task.distribution_method == 'LOGARITHMIC' ? 'Accelerated Distribution' : task.distribution_method)}}</td>
                  <td>
                    <router-link :to="'/drivers/' + task.id_driver.id_user + '/'">
                      {{task.id_driver.name_first + ' ' + task.id_driver.name_last}}
                    </router-link>
                  </td>
                  <td>
                    <!--{{moment(task.scheduled_for).format("YYYY-MM-DD HH:mm") + " (" + moment.tz(moment.tz.guess()).format('z') + ")" }}-->
                    {{ !task.scheduled_for ? 'N/A' : ride.local_timezone ? moment.utc(task.scheduled_for).tz(ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') : moment.utc(task.scheduled_for).format('MMMM Do YYYY, h:mm:ss a (z)')}}
                  </td>
                  <td>
                    <font-awesome-icon v-if="task.done_at" icon="check-circle" style="color: green;"/>
                    <font-awesome-icon v-if="task.skipped_at" icon="tachometer-alt" style="color: deepskyblue;"/>
                    <font-awesome-icon v-if="!task.deleted_at && !task.skipped_at && !task.done_at" icon="clock" style="color: grey;"/>
                    <font-awesome-icon v-if="task.deleted_at && !task.done_at" icon="times-circle" style="color: red;"/>
                  </td>
                </tr>
                <tr v-if="ride.ride_distributions.length==0" style="text-align: center;">
                  <td colspan="6">N/A</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <h4 class="card-title"><span class="lstick"></span>Notification Logs</h4>
            </div>
          </div>
          <div class="card-body">
            <table class="table table-sm table-hover">
              <thead>
              <tr>
                <th class="result-label" width="2%">Notification ID</th>
                <th class="result-label" width="10%">Type</th>
                <th class="result-label" width="10%">Method</th>
                <th class="result-label" width="10%">To</th>
                <th class="result-label" width="10%">At</th>
                <th class="result-label" width="10%">Info</th>
                <th class="result-label" width="5%">Status</th>
                <th class="result-label" width="10%">Content</th>
                <th class="result-label" width="20%">Destination</th>
              </tr>
              </thead>
              <tbody style="word-break: break-all;">
              <tr v-for="noti in ride.ride_notifications">
                <td>{{noti.id_notification}}</td>
                <td>{{noti.id_type_notification.code}}</td>
                <td>{{noti.id_type_communication_method.code}}</td>
                <td>
                  <router-link :to="'/drivers/' + noti.id_user.id_user + '/'">
                    {{noti.id_user.name_first + ' ' + noti.id_user.name_last}}
                  </router-link>
                </td>
                <td>
                  <!--{{moment(noti.created_at).format("YYYY-MM-DD HH:mm") + " (" + moment.tz(moment.tz.guess()).format('z') + ")" }}-->
                  {{ !noti.created_at ? 'N/A' : ride.local_timezone ? moment.utc(noti.created_at).tz(ride.local_timezone).format('MMMM Do YYYY, h:mm:ss a (z)') : moment.utc(noti.created_at).format('MMMM Do YYYY, h:mm:ss a (z)')}}
                </td>
                <td v-if="noti.info">{{noti.info}}</td>
                <td v-if="!noti.info">N/A</td>
                <td>
                  <font-awesome-icon v-if="noti.status" icon="check-circle" style="color: green;"/>
                  <font-awesome-icon v-if="!noti.status" icon="times-circle" style="color: red;"/>
                </td>
                <td v-if="!(noti.content && isUrl(noti.content))">{{noti.content}}</td>
                <td v-if="noti.content && isUrl(noti.content)"><a v-bind:href=noti.content>{{noti.content}}</a></td>
                <td>{{noti.destination}}</td>
              </tr>
              <tr v-if="ride.ride_notifications.length==0" style="text-align: center;">
                <td colspan="9">N/A</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>


        <!--<div class="col-12 col-lg-12">-->
          <!--<div class="card">-->
            <!--<div class="card-body">-->
              <!--<div class="d-flex">-->
                <!--<h4 class="card-title"><span class="lstick"></span>Route Tracking</h4>-->
              <!--</div>-->
            <!--</div>-->
            <!--<div class="card-body card-map-body">-->
              <!--<h3>This ride has {{p2Locations ? p2Locations.length : 'no'}} GPS location records for P2 (Green) and {{p3Locations ? p3Locations.length : 'N/A'}} for P3 (Blue).</h3>-->
              <!--<br>-->
              <!--<div class="d-flex">-->
                <!--<div id="map" style="width: 100%;height: 500px;margin: auto;"></div>-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->

      </div>
    </div>

    <!-- Add additional payment popup alert -->
    <div>
      <div>
        <!-- use the modal component, pass in the prop -->
        <modal v-if="showAdditionalModal" @close="showAdditionalModal = false">
          <h3 slot="header">
            Add Additional Payment
          </h3>
          <div slot="body">
            <form v-on:submit.prevent class="form-material">
              <div class="my-3">
                <label class="search-label">Amount: $</label>
                <input v-model="additional_payment_amount" class="form-control form-control-sm" placeholder="Amount" style="width:100%" type="text">
              </div>
              <div class="my-3">
                <label class="search-label">Comment:</label>
                <textarea v-model="additional_payment_comment" class="form-control form-control-sm" placeholder="Comment" style="width:100%; resize:auto;" rows="3">
                </textarea>
              </div>
              <!-- <span>Amount: $</span><input v-model="additional_payment_amount"/>
              <br>
              <span>Comment: </span>
              <textarea v-model="additional_payment_comment"></textarea>
              -->
            </form>
          </div>
          <div slot="footer" >
            <button class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="showAdditionalModal=false; showAdditionalModalConfirm=true">
              Add
            </button>
            <button class="modal-default-button btn btn-default m-t-10" @click="showAdditionalModal = false">
              Cancel
            </button>
          </div>
        </modal>
      </div>
    </div>


    <!-- Add additional payment confirmation popup alert -->
    <div>
      <div>
        <!-- use the modal component, pass in the prop -->
        <modal v-if="showAdditionalModalConfirm" @close="showAdditionalModalConfirm = false">
          <h3 slot="header">
            Confirm Adding Additional Payment
          </h3>
          <div slot="body">
            <h3 v-if="additional_payment_amount==8">Are you sure to add additional payment of <span style="color: green; font-weight: bold; font-size: 3rem;">${{additional_payment_amount}}</span></h3>
            <h3 v-if="additional_payment_amount!=8">Are you sure to add additional payment of <span style="color: red; font-weight: bold; font-size: 3rem;">${{additional_payment_amount}}</span></h3>
          </div>
          <div slot="footer" >
            <button class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="addAdditionalPayment('extra_payment')">
              Add
            </button>
            <button class="modal-default-button btn btn-default m-t-10" @click="showAdditionalModalConfirm = false">
              Cancel
            </button>
          </div>
        </modal>
      </div>
    </div>

    <!-- Add unloaded miles payment popup alert -->
    <div>
      <div>
        <!-- use the modal component, pass in the prop -->
        <modal v-if="showUnloadedModal" @close="showUnloadedModal = false">
          <h3 slot="header">
            Update Unloaded Miles Payment
          </h3>
          <div slot="body">
            <form v-on:submit.prevent class="form-material">
              <div class="my-3">
                <label class="search-label">Amount: $</label>
                <input v-model="ride.price_unloaded" class="form-control form-control-sm" placeholder="Amount" style="width:100%" type="text">
              </div>
            </form>
          </div>
          <div slot="footer" >
            <button class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="showUnloadedModal = false; addAdditionalPayment('unloaded_payment')">
              Update
            </button>
            <button class="modal-default-button btn btn-default m-t-10" @click="showUnloadedModal = false">
              Cancel
            </button>
          </div>
        </modal>
      </div>
    </div>

    <!-- Driver selection popup alert -->
    <div>
      <div>
        <!-- use the modal component, pass in the prop -->
        <modal v-if="showDriverSelectModal" @close="showDriverSelectModal = false">
          <h3 slot="header">
            Please select a driver
          </h3>
          <div slot="body">
            <form v-on:submit.prevent class="form-material">
              <br>
              <br>
              <select id="driver-selection" type="text" placeholder="Driver"
                      class="form-control ddown">
                <option>
                  {{driverSelectMessage}}
                </option>
                <option v-for="(item) in drivers" v-bind:key="item.id_driver.id" v-if="!item.id_driver.id_type_driver_account || (ride.deadhead && ride.deadhead == true && item.id_driver.id_type_driver_account.code == 'deadhead') ||  ((!ride.deadhead || ride.deadhead == false) && item.id_driver.id_type_driver_account.code == 'individual')">
<!-- + (item.id_driver.id_type_driver_status ? item.id_driver.id_type_driver_status.name : 'N/A') + ' - ' -->
                  {{(item.id_user ? item.id_user + " - " : '') + (item.name_first ? item.name_first : '') + " " + (item.name_last ? item.name_last : '') + ' - ' + (item.id_driver.id_type_driver_account ? item.id_driver.id_type_driver_account.code : 'N/A') + ' - ' + (item.id_driver.id_market ? item.id_driver.id_market.name : 'N/A') + ' - '  }}{{item.tags | driverTags}}
                </option>
              </select>
            </form>
            <form v-if="ride.id_driver || isAtFault" v-on:submit.prevent class="form-material">
              <div class="my-3">
                <input type="checkbox" v-model="isAtFault" id="is_at_fault_checkbox"/>
                <label class="search-label" for="is_at_fault_checkbox">
                  Current driver, {{ride.id_driver.name_first}} {{ride.id_driver.name_last}}, at fault.
                </label>
              </div>
              <div v-if="isAtFault" class="my-3">
                <label class="search-label">Please describe:</label>
                <textarea v-model="atFaultDescription" class="form-control form-control-sm" placeholder="..." style="width:100%; resize:auto;" rows="3">
                </textarea>
              </div>
            </form>
          </div>
          <div slot="footer" >
            <button class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="showDriverSelectModal = false; assign($event)">
              Submit
            </button>
            <button class="modal-default-button btn btn-default m-t-10" @click="showDriverSelectModal = false; isLoading = false">
              Cancel
            </button>
          </div>
        </modal>
      </div>
    </div>

    <!-- Proxy interactions -->
    <div>
      <div>
        <!-- use the modal component, pass in the prop -->
        <modal v-if="showProxyInteractionsModal" @close="showProxyInteractionsModal = false">
          <h3 slot="header">
            Proxy Events
          </h3>
          <div slot="body">
            <table style="border-collapse: separate;border-spacing: 30px 0;">
              <thead>
              <tr>
                <th>By</th>
                <th>Content</th>
                <th>Created at</th>
                <th>Delivery Status</th>
                <th>Proxy Number</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="interaction in [].concat(ride.proxy.interactions).reverse()">
                <td>
                  {{interaction.sender_type ? interaction.sender_type : "System"}}
                </td>
                <td>
                  {{interaction.content}}
                </td>
                <td>
                  {{moment.utc(interaction.created_at).tz(ride.local_timezone).format('MM/DD/YY  HH:mm z')}}
                </td>
                <td>
                  {{interaction.mb_delivery_status ? interaction.mb_delivery_status : 'N/A'}}
                </td>
                <td>
                  {{interaction.proxy_number ? parsePhoneNumber('+' + interaction.proxy_number).formatNational() : 'N/A'}}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div slot="footer" >
            <button class="modal-default-button btn btn-default m-t-10" @click="showProxyInteractionsModal = false; isLoading = false">
              Done
            </button>
          </div>
        </modal>
      </div>
    </div>

    <!-- Status selection popup alert -->
    <div>
      <div>
        <!-- use the modal component, pass in the prop -->
        <modal v-if="showStatusSelectModal" @close="showStatusSelectModal = false">
          <h3 slot="header">
            Please select a status
          </h3>
          <div slot="body">
            <h6 style="color: red;">
              * This operation might reset most attributes of this ride, use with extreme caution!
            </h6>
            <form v-on:submit.prevent class="form-material">
              <br>
              <br>
              <select id="status-selection" type="text" placeholder="None"
                      class="form-control ddown">
                <option>
                  Please select a status
                </option>
                <option v-for="(item) in statuses">
                  {{item}}
                </option>
              </select>
            </form>
          </div>
          <div slot="footer" >
            <button class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="showStatusSelectModal = false; changeStatus($event)">
              Submit
            </button>
            <button class="modal-default-button btn btn-default m-t-10" @click="showStatusSelectModal = false; isLoading = false">
              Cancel
            </button>
          </div>
        </modal>
      </div>
    </div>

    <!-- See something say something form -->
    <div>
      <div>
        <!-- use the modal component, pass in the prop -->
        <modal v-if="showSSSSModal" @close="showSSSSModal = false">
          <h3 slot="header">
            See Something Say Something
          </h3>
          <div slot="body" v-if="observation != null">
            <form v-on:submit.prevent class="form-material">
              <div class="my-3">
                <label class="search-label">No-Show Type:</label>
                <!--<input v-model="observation.noshow_type" class="form-control form-control-sm" placeholder="N/A" style="width:100%" type="text">-->
                <h6>
                  {{ observation.noshow_type ? observation.noshow_type : "N/A"}}
                </h6>
              </div>
              <div class="my-3">
                <label class="search-label">Spoke With:</label>
                <!--<input v-model="observation.spoke_with" class="form-control form-control-sm" placeholder="N/A" style="width:100%" type="text">-->
                <h6>
                  {{ observation.spoke_with ? observation.spoke_with : "N/A"}}
                </h6>
              </div>
              <div class="my-3">
                <label class="search-label">Noticed At:</label>
                <!--<input v-model="observation.noticed_At" class="form-control form-control-sm" placeholder="N/A" style="width:100%" type="text">-->
                <h6>
                  {{ observation.noticed_at && observation.noticed_at != 'Nothing' ? observation.noticed_at : "N/A"}}
                </h6>
              </div>
              <div class="my-3">
                <label class="search-label">Environment:</label>
                <!--<input v-model="observation.environment" class="form-control form-control-sm" placeholder="N/A" style="width:100%" type="text">-->
                <h6>
                  {{ observation.environment && observation.environment != 'Nothing'  ? observation.environment : "N/A"}}
                </h6>
              </div>
              <div class="my-3">
                <label class="search-label">Person:</label>
                <!--<input v-model="observation.person" class="form-control form-control-sm" placeholder="N/A" style="width:100%" type="text">-->
                <h6>
                  {{ observation.person && observation.person != 'Nothing'  ? observation.person : "N/A"}}
                </h6>
              </div>
              <div class="my-3">
                <label class="search-label">Description:</label>
                <!--<input v-model="observation.description" class="form-control form-control-sm" placeholder="N/A" style="width:100%" type="text">-->
                <h6>
                  {{ observation.description ? observation.description : "N/A"}}
                </h6>
              </div>
            </form>
          </div>
          <div slot="body" v-else>
            <h6>
              No form found
            </h6>
          </div>
          <div slot="footer" >
            <button class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="showSSSSModal = false">
              Okay
            </button>
          </div>
        </modal>
      </div>
    </div>

    <!-- Send-back confirmation popup alert -->
    <div id="sendBackConfirmation">
      <modal v-if="showSendBackModal" @close="showSendBackModal = false">
        <h3 slot="header">Confirm Ride Send-Back</h3>
        <div slot="body">
          <div class="my-3">
            <input type="checkbox" v-model="sendBack" id="sendback_checkbox"/>
            <label class="search-label" for="sendback_checkbox">
              Send back cancellation status to Verida.
            </label>
          </div>
          <form v-if="ride.id_driver || isAtFault" v-on:submit.prevent class="form-material">
            <div class="my-3">
              <input type="checkbox" v-model="isAtFault" id="is_at_fault_checkbox"/>
              <label class="search-label" for="is_at_fault_checkbox">
                Current driver, {{ride.id_driver.name_first}} {{ride.id_driver.name_last}}, at fault.
              </label>
            </div>
            <div v-if="isAtFault" class="my-3">
              <label class="search-label">Please describe:</label>
              <textarea v-model="atFaultDescription" class="form-control form-control-sm" placeholder="..." style="width:100%; resize:auto;" rows="3">
              </textarea>
            </div>
          </form>
        </div>
        <div slot="footer" >
          <button class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="showSendBackModal = false; updateRide('cancel')">
            Submit
          </button>
          <button class="modal-default-button btn btn-default m-t-10" @click="showSendBackModal = false">
            Cancel
          </button>
        </div>
      </modal>
    </div>

    <!-- At-fault form popup alert -->
    <div id="atFaultForm">
      <modal v-if="showAtFaultModal" @close="showAtFaultModal = false">

        <h3 slot="header">
          {{ atFaultPopupTitle[atFaultTransferType] }}
        </h3>

        <div slot="body">
          <form v-if="ride.id_driver" v-on:submit.prevent class="form-material">
            <div class="my-3">
              <input type="checkbox" v-model="isAtFault" id="is_at_fault_checkbox"/>
              <label class="search-label" for="is_at_fault_checkbox">
                Current driver, {{ride.id_driver.name_first}} {{ride.id_driver.name_last}}, at fault.
              </label>
            </div>
            <div v-if="isAtFault" class="my-3">
              <label class="search-label">Please describe:</label>
              <textarea v-model="atFaultDescription" class="form-control form-control-sm" placeholder="..." style="width:100%; resize:auto;" rows="3">
              </textarea>
            </div>
          </form>
        </div>

        <div slot="footer" >
          <button class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="showAtFaultModal = false; updateRide(atFaultTransferType)">
            Submit
          </button>
          <button class="modal-default-button btn btn-default m-t-10" @click="showAtFaultModal = false; atFaultTransferType = null">
            Cancel
          </button>
        </div>

      </modal>
    </div>

    <!-- Pricing data popup alert -->
    <div id="pricingdata">
      <modal v-if="showPricingData" @close="showPricingData = false">
        <h3 slot="header">Pricing data</h3>
        <h5 slot="body">
          <div style="width: 100%; background-color: #f7fafc; box-shadow: inset 0 1px #e3e8ee; padding: 1.25rem;">
            <div v-if="ride.pricing_data">
              <json-viewer :value="JSON.parse(ride.pricing_data)"
                           :expand-depth=5
                           copyable></json-viewer>
            </div>
            <div v-else>
              <span>N/A</span>
            </div>
          </div>
        </h5>
        <div slot="footer" >
          <button style="width: 80px; margin-left: 10px;" class="modal-default-button btn btn-info waves-effect waves-light m-t-10" @click="showPricingData = false;">
            OK
          </button>
        </div>
      </modal>
    </div>

  </div>
</template>

<script>
import Vue from "vue";

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

// register modal component
Vue.component("modal", {
  template: "#modal-template",
});

export default {
  metaInfo: {
    title: "Wingz Support | Rides",
  },
  name: "Rides",
  data() {
    return {
      isLoading: false,
      loadings: [],
      ride: null,
      comments: [],
      comment_content: null,
      geostamp_edit: false,
      geocheck_bk: null,
      geoenroute_bk: null,
      geopickup_bk: null,
      geodropoff_bk: null,
      triplegid_edit: false,
      triplegid_bk: null,
      pickup_edit: false,
      pickup_bk: null,
      instructions_edit: false,
      instructions_bk: null,
      odometer_edit: false,
      pickup_odometer_bk: null,
      dropoff_odometer_bk: null,
      updateMessage: {
        cancel: "Are you sure you want to cancel this ride?",
        odometer:
          "Are you sure you want to update the pick-up and drop-off odometers?",
        ridernoshow:
          "Are you sure you want to mark this ride as a Rider No-Show?",
        drivernoshow:
          "Are you sure you want to mark this ride as a Driver No-Show?",
        instructions: "Are you sure you want to update the instructions?",
        linear:
          "Are you sure you want to distribute this ride through general distribution?",
        logarithmic:
          "Are you sure you want to distribute this ride through accelerated distribution?",
        date_pickup: "Are you sure you want to update the pick-up date?",
        id_alternate: "Are you sure you want to update the Trip Leg ID?",
        blast: "Are you sure you want to blast this ride?",
        geostamp: "Are you sure you want to update the time?",
      },
      showAdditionalModal: false,
      showAdditionalModalConfirm: false,
      showSSSSModal: false,
      showPricingData: false,
      additional_payment_amount: null,
      additional_payment_comment: null,
      showDriverSelectModal: false,
      showProxyInteractionsModal: false,
      showStatusSelectModal: false,
      showSendBackModal: false,
      showUnloadedModal: false,
      showAtFaultModal: false,
      atFaultTransferType: null,
      atFaultPopupTitle: {
        cancel: "Confirm Cancel Ride",
        linear: "Confirm General Distribution",
        blast: "Confirm Blast Ride",
        drivernoshow: "Confirm Driver No-Show",
      },
      isAtFault: false,
      atFaultDescription: null,
      sendBack: true,
      driverSelectMessage: "Select a driver",
      drivers: [],
      statuses: [
        "Accept",
        "En-route",
        "Pick-up",
        "Drop-off",
        "Paid-denied",
        "Complete",
      ],
      observation: null,
      map: null,
      p2Locations: null,
      p3Locations: null,
      requestedP3: false,
      vehicleType: "",
    };
  },
  components: {
    Loading,
  },
  computed: {
    // a computed getter
    rideVehicleType() {
      console.log(this.ride)
      var vehicle_type = null;
      if (this.ride.tag_values && this.ride.tag_values.length > 0) {
        for (var i=0; i < this.ride.tag_values.length; i++) {
          if (this.ride.tag_values[i].code == "vehicle_type" && this.ride.tag_values[i].values) {
            for (var j=0; j < this.ride.tag_values[i].values.length; j++) {
              if (!vehicle_type) {
                vehicle_type = this.ride.tag_values[i].values[j].value
              } else {
                vehicle_type = vehicle_type + ", " + this.ride.tag_values[i].values[j].value
              }
            }
          }
        }
      }
      return vehicle_type;
    }
  },
  methods: {
    isUrl: function (str) {
      return str.startsWith("http");
    },
    showDriverSelect: function (event) {
      this.getAllDrivers();
    },
    async getVehicleType(id) {
      await this.$http
        .get(process.env.API_BASE_URL_CS + "driver-tags/?driver=" + id)
        .then((response) => {
          let tempArr = [];
          response.data.forEach((element) => {
            tempArr.push(element.value);
          });

          this.vehicleType = tempArr.length ? tempArr.join(", ") : "NA";
        })
        .catch((error) => {
          console.log(error);
        });
    },
    assign: function (event) {
      var choice = document.getElementById("driver-selection").value;
      if (choice == this.driverSelectMessage) {
        Vue.toasted.show("Please select a driver", {
          theme: "bubble",
          position: this.toastPosition,
          duration: 2000,
        });
      } else {
        this.isLoading = true;
        choice = choice.split(" - ")[0];
        let params = { designated_id_driver: choice };
        if (this.isAtFault) {
          params.at_fault_description = this.atFaultDescription;
        }
        this.$http
          .patch(
            process.env.API_BASE_URL_CS +
              "rides/" +
              this.$route.params.id_ride +
              "/?type=assign",
            params
          )
          .then((response) => {
            // this.$delete(this.data.pool, count)
            this.drivers = response;
          })
          .catch((error) => {
            this.check403(error);
            if (
              !error.response.status.isEmpty() &&
              error.response.status == 401
            ) {
              console.warn("redirect to login");
              this.handle401();
            }
            // Vue.toasted.show('Unable to assign!', {
            //   theme: 'bubble',
            //   position: this.toastPosition,
            //   duration: 2000
            // })
            console.log(error.response);
            this.errors = error.response.data;
            this.non_field_errors = error.response.data.non_field_errors;
          })
          .finally(() => {
            this.showDriverSelectModal = false;
            this.clearAtFaultForm()
            this.isLoading = false;
            setTimeout(this.getRide(), 300);
          });
      }
    },
    getAllDrivers: function () {
      this.isLoading = true;
      this.$http
        .get(
          process.env.API_BASE_URL_CS +
            "drivers-search/?id_driver__id_type_driver_status=1" +
            "&id_driver__id_market=" +
            this.ride.id_market.id_market +
            (this.rideVehicleType ? "&vehicle_type=" + this.rideVehicleType : "") +
            "&tags=26"
          // + (this.ride.deadhead == false ? '' : '&id_driver__id_type_driver_account=5')
        )
        .then((response) => {
          this.drivers = response.data;
          if (this.drivers.length == 0) {
            this.drivers.push({
              id_user: 0,
              name_first: "No available drivers",
            });
          }
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          // Vue.toasted.show('Unable to retrieve markets!', {
          //   theme: 'bubble',
          //   position: this.toastPosition,
          //   duration: 2000
          // })
          console.log(error.response);
          this.errors = error.response.data;
          this.non_field_errors = error.response.data.non_field_errors;
        })
        .finally(() => {
          this.isLoading = false;
          this.showDriverSelectModal = true;
        });
    },
    addAdditionalPayment(code, description) {
      this.showLoading();
      var params = {
        id_ride: this.$route.params.id_ride,
      };
      if (code == "unloaded_payment") {
        params["amount"] = this.ride.price_unloaded;
      } else {
        params["amount"] = this.additional_payment_amount;
        params["comment"] = this.additional_payment_comment;
      }
      this.$http
        .post(
          process.env.API_BASE_URL_CS + "transactions/?type=" + code,
          params
        )
        .then((response) => {
          this.showAdditionalModal = false;
          this.showAdditionalModalConfirm = false;
          this.additional_payment_amount = null;
          this.additional_payment_comment = null;
          this.getRide();
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error.response);

          error = error.response.data;
          if ("non_field_errors" in error) {
            error = error["non_field_errors"][0];
          } else {
            if (Array.isArray(error)) {
              error = error[0];
            } else {
              let name = Object.keys(error)[0];
              error = error[name][0] + " for " + name + ".";
            }
          }
          this.showToastError(error);
        })
        .finally(() => {
          this.hideLoading();
        });
      this.showUnloadedModal = false;
    },
    changeStatus(type) {
      var status = document.getElementById("status-selection").value;
      if (status == "Please select a status") {
        Vue.toasted.show("Please select a status", {
          theme: "bubble",
          position: this.toastPosition,
          duration: 2000,
        });
        return;
      }

      this.showLoading();

      this.$http
        .patch(
          process.env.API_BASE_URL_CS +
            "rides/" +
            this.$route.params.id_ride +
            "/?type=changeStatus",
          {
            status: status,
          }
        )
        .then((response) => {})
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error.response);

          error = error.response.data;
          if ("non_field_errors" in error) {
            error = error["non_field_errors"][0];
          } else {
            if (Array.isArray(error)) {
              error = error[0];
            } else {
              let name = Object.keys(error)[0];
              error = error[name][0].replace(
                "This field",
                this.field_name[name]
              );
              error = error.replace("this field", this.field_name[name]);
              error = error.replace(
                "Enter a valid email address.",
                "Invalid email address."
              );
            }
          }

          this.showToastError(error);
        })
        .finally(() => {
          this.hideLoading();
          this.getRide();
        });
    },
    showLoading() {
      this.isLoading = true;
      this.loadings.push(1);
    },
    hideLoading() {
      if (this.loadings.length > 0) {
        this.loadings.pop();
      }
      if (this.loadings.length == 0) {
        this.isLoading = false;
      }
    },
    getComments: function () {
      this.showLoading();
      this.$http
        .get(
          process.env.API_BASE_URL_CS +
            "ride-comments/?id_ride=" +
            this.$route.params.id_ride
        )
        .then((response) => {
          let comments = []
          for (let index in response.data.results) {
            if (response.data.results[index].commented_by.email != 'system@wingz.com') {
              comments.push(response.data.results[index])
            }
          }
          this.comments = comments.reverse();
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error.response);
        })
        .finally(() => {
          this.hideLoading();
          if (this.comments && this.comments.length > 0) {
            $("#comments-table").DataTable({
              displayLength: 5,
              lengthMenu: [5, 10, 25, 50],
              lengthChange: true,
              searching: false,
              ordering: false,
              retrieve: true,
            });
          }
        });
    },
    getObservation: function () {
      this.showLoading();
      this.$http
        .get(
          process.env.API_BASE_URL_CS +
            "observation/?id=" +
            this.$route.params.id_ride
        )
        .then((response) => {
          if (response.data.length > 0) {
            this.observation = response.data[0];
          }
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error.response);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    formatPhoneNumber: function (phoneNumberString) {
      var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
      var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        var intlCode = (match[1] ? '+1 ' : '');
        return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
      }
      return null;
    },
    createProxy: function () {
      this.showLoading();
      this.$http
        .post(process.env.API_BASE_URL_CS + "create-proxy/", {
          id_business_provider: this.ride.id_business_provider,
          id_ride: this.$route.params.id_ride,
          rider_phone_number: this.ride.contact_phone,
          driver_phone_number: this.ride.id_driver.phone_number,
        })
        .then((response) => {
          this.getRide();
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.error(error.response);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    changeProxyNumber: function () {
      this.showLoading();
      this.$http
        .post(process.env.API_BASE_URL_CS + "change-proxy-number/", {
          id_business_provider: this.ride.id_business_provider,
          id_ride: this.$route.params.id_ride,
          rider_phone_number: this.ride.contact_phone,
          driver_phone_number: this.ride.id_driver.phone_number,
        })
        .then((response) => {
          this.getRide();
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.error(error.response);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    closeProxy: function () {
      this.showLoading();
      this.$http
        .post(process.env.API_BASE_URL_CS + "close-proxy/", {
          id_business_provider: this.ride.id_business_provider,
          id_ride: this.$route.params.id_ride,
        })
        .then((response) => {
          this.getRide();
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.error(error.response);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    removeProxy: function () {
      this.showLoading();
      this.$http
        .post(process.env.API_BASE_URL_CS + "remove-proxy/", {
          id_business_provider: this.ride.id_business_provider,
          id_ride: this.$route.params.id_ride,
        })
        .then((response) => {
          this.getRide();
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.error(error.response);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    addComment: function () {
      this.showLoading();
      this.$http
        .post(process.env.API_BASE_URL_CS + "ride-comments/", {
          id_ride: this.$route.params.id_ride,
          content: this.comment_content,
        })
        .then((response) => {
          this.comment_content = null;
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error.response);
        })
        .finally(() => {
          this.hideLoading();

          this.getComments();
        });
    },
    getRide: function () {
      this.showLoading();
      this.$http
        .get(
          process.env.API_BASE_URL_CS +
            "rides/" +
            this.$route.params.id_ride +
            "/"
        )
        .then((response) => {
          this.ride = response.data ? response.data : null;
          if (this.ride.id_driver)
            this.getVehicleType(this.ride.id_driver.id_user);
        })
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error);
        })
        .finally(() => {
          this.hideLoading();

          // this.drawPickupDropoff()
        });
    },
    drawPickupDropoff: function () {
      var myLatlng = new google.maps.LatLng(
        this.ride["default_pickup_latitude"],
        this.ride["default_pickup_longitude"]
      );
      var mapOptions = {
        zoom: 11,
        center: myLatlng,
      };
      this.map = new google.maps.Map(
        document.getElementById("map"),
        mapOptions
      );

      // var marker = new google.maps.Marker({
      //   position: myLatlng,
      //   title:"Hello World!"
      // });
      //
      // // To add the marker to the map, call setMap();
      // marker.setMap(map);

      let label = {
        color: "red", // <= HERE
        fontSize: "11px",
        fontWeight: "900",
        text: "Scheduled Pick-up",
      };

      let marker = new google.maps.Marker({
        position: new google.maps.LatLng(
          this.ride["default_pickup_latitude"],
          this.ride["default_pickup_longitude"]
        ),
        icon: {
          path: google.maps.SymbolPath.BACKWARD_CLOSED_ARROW,
          scale: 9,
          strokeColor: "blue",
        },
        label: label,
        map: this.map,
      });

      let label2 = {
        color: "red", // <= HERE
        fontSize: "11px",
        fontWeight: "900",
        text: "Scheduled Drop-off",
      };

      let marker2 = new google.maps.Marker({
        position: new google.maps.LatLng(
          this.ride["default_dropoff_latitude"],
          this.ride["default_dropoff_longitude"]
        ),
        icon: {
          path: google.maps.SymbolPath.BACKWARD_CLOSED_ARROW,
          scale: 9,
          strokeColor: "red",
        },
        label: label2,
        map: this.map,
      });

      this.getLocations("p2");
    },
    getLocations: function (type) {
      this.showLoading();
      this.$http
        .get(
          process.env.API_BASE_URL_CS +
            "locations/?id_ride=" +
            this.$route.params.id_ride +
            "&type=" +
            type
        )
        .then((response) => {
          if (type == "p2") {
            this.p2Locations = response.data ? response.data : [];
          } else {
            this.p3Locations = response.data ? response.data : [];
          }

          let locations = response.data ? response.data : null;
          if (locations.length != 0) {
            // var marker = new google.maps.Marker({
            //   position: myLatlng,
            //   title:"Hello World!"
            // });
            //
            // // To add the marker to the map, call setMap();
            // marker.setMap(map);

            for (let i = 0; i < locations.length; i++) {
              if (type == "p2" && i == 0) {
                let label2 = {
                  color: "red", // <= HERE
                  fontSize: "11px",
                  fontWeight: "900",
                  text: "En-route Location",
                };

                let marker2 = new google.maps.Marker({
                  position: new google.maps.LatLng(
                    locations[i]["lat"],
                    locations[i]["lng"]
                  ),
                  icon: {
                    path: google.maps.SymbolPath.BACKWARD_CLOSED_ARROW,
                    scale: 9,
                    strokeColor: "green",
                  },
                  label: label2,
                  map: this.map,
                });
              }

              let label = {
                color: "red", // <= HERE
                fontSize: "11px",
                fontWeight: "900",
                text: "" + i,
              };

              let marker = new google.maps.Marker({
                position: new google.maps.LatLng(
                  locations[i]["lat"],
                  locations[i]["lng"]
                ),
                icon: {
                  path: google.maps.SymbolPath.CIRCLE,
                  scale: 7,
                  strokeColor: type == "p2" ? "green" : "blue",
                },
                label: label,
                map: this.map,
                title: locations[i]["created_at"],
              });
            }
          }

          if (this.p3Locations == null && this.requestedP3 == false) {
            this.requestedP3 = true;
            this.getLocations("p3");
          }
        })
        .catch((error) => {
          // this.check403(error);
          // if (error.response.status == 401) {
          //   console.warn("redirect to login")
          //   this.handle401()
          // }
          console.log(error);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    updateRide: function (type) {
      if (!confirm(this.updateMessage[type])) {
        if (type == "instructions") {
          this.ride.instructions = this.instructions_bk;
        } else if (type == "date_pickup") {
          this.ride.date_pickup = this.instructions_bk;
        } else if (type == "odometer") {
          this.ride.pickup_odometer = this.pickup_odometer_bk;
          this.ride.dropoff_odometer = this.dropoff_odometer_bk;
        } else if (type == "id_alternate") {
          this.ride.id_alternate = this.triplegid_bk;
        } else if (type == "geostamp") {
          this.ride.check_date = this.geocheck_bk;
          this.ride.enroute_date = this.geoenroute_bk;
          this.ride.pickup_date = this.geopickup_bk;
          this.ride.dropoff_date = this.geodropoff_bk;
        }
        return;
      }
      if (this.ride.pickup_odometer && this.ride.dropoff_odometer && parseInt(this.ride.pickup_odometer) > parseInt(this.ride.dropoff_odometer)) {
        alert('Drop-off odometer should be larger than the pick-up odometer.')
        this.odometer_edit = true;
        return
      }
      this.showLoading();
      var params = {
        instructions: this.ride.instructions,
        date_pickup: this.ride.date_pickup,
        pickup_odometer: this.ride.pickup_odometer
          ? this.ride.pickup_odometer
          : 0,
        dropoff_odometer: this.ride.dropoff_odometer
          ? this.ride.dropoff_odometer
          : 0,
        id_alternate: this.ride.id_alternate,
        sendBack: this.sendBack,
      };
      if (this.ride.check_date) {
        params.check_date = this.ride.check_date;
      }
      if (this.ride.enroute_date) {
        params.enroute_date = this.ride.enroute_date;
      }
      if (this.ride.pickup_date) {
        params.pickup_date = this.ride.pickup_date;
      }
      if (this.ride.dropoff_date) {
        params.dropoff_date = this.ride.dropoff_date;
      }
      if (this.isAtFault) {
        params.at_fault_description = this.atFaultDescription;
      }
      this.$http
        .patch(
          process.env.API_BASE_URL_CS +
            "rides/" +
            this.$route.params.id_ride +
            "/?type=" +
            type,
          params
        )
        .then((response) => {
          this.getRide();
        })
        .catch((error) => {
          if (["cancel"].includes(type)) {
            this.odometer_edit = true;
          }

          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          if (error.response.status == 400) {
            let errMsg = Object.values(error.response.data).flat();
            alert(errMsg);
            //alert(error.response.data[0])
          }
        })
        .finally(() => {
          this.hideLoading();
          this.clearAtFaultForm();
        });
    },
    popupAtFaultForm: function (type) {
      if (this.ride.id_driver) {
        if (type == 'drivernoshow') {
          this.isAtFault = true;
        }
        this.atFaultTransferType = type;
        this.showAtFaultModal = true;
      } else {
        this.updateRide(type);
      }
    },
    clearAtFaultForm: function () {
      this.atFaultTransferType = null;
      this.isAtFault = false;
      this.atFaultDescription = null;
    },
    blacklistDriver: function () {
      if (this.ride.id_driver != null) {
        this.showLoading();
        this.$http
          .post(process.env.API_BASE_URL_CS + "blacklist-driver/", {
            id_rider: this.ride.id_rider.id_user,
            id_driver: this.ride.id_driver.id_user,
            id_user_action: this.getUser().id_user,
          })
          .then((response) => {
            this.getRide();
          })
          .catch((error) => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login");
              this.handle401();
            }
            console.log(error.response);
          })
          .finally(() => {
            this.hideLoading();
          });
      } else {
        this.showToastError("No driver for this ride");
      }
    },
    confirmRide: function () {
      this.showLoading();
      this.$http
        .post(process.env.API_BASE_URL_CS + "make-ride-confirmation/", {
          id_ride: this.ride.id_ride,
        })
        .then((response) => {})
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error.response);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    confirmRideVoice: function () {
      this.showLoading();
      this.$http
        .post(
          process.env.API_BASE_URL_CS + "make-outbound-call/ride-confirmation/",
          {
            id_ride: this.ride.id_ride,
          }
        )
        .then((response) => {})
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error.response);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    confirmRideSms: function () {
      this.showLoading();
      this.$http
        .post(
          process.env.API_BASE_URL_CS + "make-outbound-text/ride-confirmation/",
          {
            id_ride: this.ride.id_ride,
          }
        )
        .then((response) => {})
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error.response);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    favoriteDriver: function () {
      if (this.ride.id_driver != null) {
        this.showLoading();
        this.$http
          .post(process.env.API_BASE_URL_CS + "favorite-driver/", {
            id_rider: this.ride.id_rider.id_user,
            id_driver: this.ride.id_driver.id_user,
          })
          .then((response) => {
            this.getRide();
          })
          .catch((error) => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login");
              this.handle401();
            }
            console.log(error.response);
          })
          .finally(() => {
            this.hideLoading();
          });
      } else {
        this.showToastError("No driver for this ride");
      }
    },
    markRideSigned: function (id_ride) {
      this.showLoading();
      this.$http
        .patch(
          process.env.API_BASE_URL_CS +
            "rides/" +
            id_ride +
            "/?type=mark_signed",
          {}
        )
        .then((response) => {})
        .catch((error) => {
          this.check403(error);
          if (error.response.status == 401) {
            console.warn("redirect to login");
            this.handle401();
          }
          console.log(error);
          this.errored = true;
        })
        .finally(() => {
          this.hideLoading();
          this.getRide();
        });
    },
  },
  mounted() {
    this.getRide();
    this.getComments();
    this.getObservation();
  },
  created() {
    // document.title = "Wingz Support | Rides";
  },
};
</script>

<style scoped>
.actions button {
  color: #333268;
  background-color: #00f9b9;
  border: none;
  margin-bottom: 5px;
}

.actions button:hover {
  background-color: red;
}
.edit-instructions {
  resize: auto;
  width: 100%;
}

#pricingdata .modal-mask {
  width: 80%;
  height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/Rides.vue